// main.js

// import "lazysizes"; // For use with lazysizes_support config option

import Disclosure from "./scripts/utils/Disclosure.js";
import Dialog from "./scripts/utils/Dialog.js";

import Accordion from "./scripts/components/Accordion.js";
import basicFilter from "./scripts/components/BasicFilter.js";
import CogCredits from "./scripts/components/CogCredits.js";
import EventDetail from "./scripts/components/EventDetail.js";
import LoadingIndicator from "./scripts/components/LoadingIndicator.js";
//import Map from "./scripts/components/Map.js";
import MediaGallery from "./scripts/components/MediaGallery.js";
import MenuShading from "./scripts/components/MenuShading.js";
import FilterListing from "./scripts/components/FilterListing.js";
import RelatedContent from "./scripts/components/RelatedContent.js";


import SiteHeader from "./scripts/components/SiteHeader.js";
import SearchResults from "./scripts/components/SearchResults.js";
import VimeoHero from "./scripts/components/VimeoHero.js";
import WhatsOnFilter from "./scripts/components/WhatsOnFilter.js";
import WhatSparksInterest from "./scripts/components/WhatSparksInterest.js";
import YouTubeHero from "./scripts/components/YouTubeHero.js";